import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';

export default ({ message, onClose, title }) => {
	const modal = useRef();
	useEffect(() => {
		if (modal.current) {
			modal.current.show();
		}
	}, [modal.current]);
	return (
		<div className="modal fade" ref={el => {
			if (modal.current) return;
			modal.current = new Modal(el);
			el.addEventListener('hidden.bs.modal', () => {
				modal.current.dispose();
				onClose && onClose();
			});
		}} tabIndex="-1">
			<div className="modal-dialog modal-dialog-centered">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title"><i className="fa fa-exclamation-triangle me-3"></i>{title}</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						<p>{message}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
